module.exports = __webpack_public_path__ + "static/icons/icon-unlock-app-bac67d546451342b64338e0596fb3ed6.svg";